import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Image from '../../components/AppImage';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { MdMenu } from "react-icons/md";

const aboutPageBgStyle = `
.about-page {
  background: linear-gradient(135deg, #233c2e 0%, #2e2540 100%);
  min-height: 100vh;
}
`;

const AboutPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [previewImg, setPreviewImg] = useState(null);

  // Anglican College Owerri core values (example)
  const coreValues = [
    {
      icon: 'BookOpen',
      title: 'Academic Excellence',
      description: 'We strive for the highest standards in academics and personal development.'
    },
    {
      icon: 'Users',
      title: 'Community',
      description: 'Fostering a supportive and inclusive school environment.'
    },
    {
      icon: 'Lightbulb',
      title: 'Innovation',
      description: 'Encouraging creativity and critical thinking in all students.'
    },
    {
      icon: 'Target',
      title: 'Discipline',
      description: 'Promoting discipline and responsibility in every student.'
    },
    {
      icon: 'Globe',
      title: 'Service',
      description: 'Instilling a commitment to service and leadership.'
    }
  ];

  // Leadership (example)
  const facultyMembers = [
    {
      name: 'Mrs Chinenye Confidence Imuo',
      position: 'Principal',
      qualification: 'B.Ed, M.Ed',
      experience: '15 years',
      photo: '/assets/images/director-pic.jpeg'
    }
  ];

  // Facilities (example)
  const facilities = [
    {
      name: 'Music lab',
      description: 'Modern labs for practical science education.',
      icon: 'Flask'
    },
    {
      name: 'Classroom',
      description: 'Modern classrooms for effective learning.',
      icon: 'BookOpen'
    },
    {
      name: 'Sewing/Tailoring Lab',
      description: 'Facilities for practical sewing and tailoring education.',
      icon: 'Trophy'
    },
    {
      name: 'ICT Centre',
      description: 'Computer lab for digital literacy.',
      icon: 'Computer'
    },
    {
      name: 'Hostels',
      description: 'Comfortable accommodation for students.',
      icon: 'Home'
    },
    {
      name: 'School Class Building',
      description: 'Modern classrooms for effective learning.',
      icon: 'Building'
    }
  ];

  // School images (replace with Anglican College Owerri images)
  const schoolImages = [
    {
      src: '/assets/images/anglican-college-gate.jpg',
      alt: 'Front Gate',
      caption: 'Front Gate'
    },
    {
      src: '/assets/images/envirnment 2.jpeg',
      alt: 'Main Building',
      caption: 'school structrues and avenue'
    },
    {
      src: '/assets/images/tailoring-students.jpeg',
      alt: 'Sewing/Tailoring Lab',
      caption: 'Sewing/Tailoring Lab'
    },
    {
      src: '/assets/images/student-in-class.jpeg',
      alt: 'Classroom',
      caption: 'Classroom'
    },
    {
      src: '/assets/images/environment.jpeg',
      alt: 'School Environment',
      caption: 'School Environment'
    },
     {
      src: '/assets/images/chapel.jpeg',
      alt: 'Chapel',
      caption: 'The Chapel'
    },
     {
      src: '/assets/images/hero-section-students 1.png',
      alt: 'School Environment',
      caption: 'the computer lab'
    },
     {
      src: '/assets/images/class building.jpeg',
      alt: 'Class Building',
      caption: 'Class Building'
    },
     {
      src: '/assets/images/class pic2.jpeg',
      alt: 'School Environment',
      caption: ''
    }

    
    // Add more images as needed
  ];

  const handleNavigation = (path) => {
    window.location.href = path;
  };

  return (
    <>
      <style>{aboutPageBgStyle}</style>
      <div className="about-page min-h-screen bg-background">
        {/* Navigation Header */}
        <header className="fixed top-0 left-0 right-0 bg-card/95 backdrop-blur-md border-b border-border z-50 rounded-b-2xl shadow-lg">
          <div className="container mx-auto px-4 lg:px-6">
            <div className="flex items-center justify-between h-16">
              {/* Logo */}
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 rounded-full overflow-hidden border-4 border-primary/30 bg-white shadow-lg">
                  <Image 
                    src="/assets/images/school_logo-1754996036714.jpg"
                    alt="Anglican College Owerri Logo"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h1 className="font-heading font-bold text-lg text-foreground tracking-wide">ANGLICAN COLLEGE OWERRINTA</h1>
                  <p className="font-caption text-xs text-muted-foreground tracking-widest">EXCELLENCE THROUGH DILLIGENCE</p>
                </div>
              </div>
              {/* Desktop Navigation */}
              <nav className="hidden md:flex items-center space-x-6">
                <button 
                  onClick={() => handleNavigation('/landing-page')}
                  className="font-body text-sm text-foreground hover:text-primary transition-colors"
                >
                  Home
                </button>
                <button className="font-body text-sm text-primary font-semibold">
                  About
                </button>
              <button 
  onClick={() => handleNavigation('/admissions&programs')}
  className="font-body text-sm text-foreground hover:text-primary transition-colors"
>
  Admissions & Updates
</button>
                <button 
                  onClick={() => handleNavigation('/contact')}
                  className="font-body text-sm text-foreground hover:text-primary transition-colors"
                >
                  Contact
                </button>
              </nav>
              {/* CTA Buttons */}
              <div className="hidden md:flex items-center space-x-3">
                <Button 
                  variant="outline" 
                  onClick={() => handleNavigation('/login-authentication')}
                  className="font-body text-sm border-primary text-primary hover:bg-primary hover:text-white transition-colors rounded-lg shadow-sm"
                >
                  Login
                </Button>
              </div>
              {/* Mobile Menu Toggle */}
              <button
                className="md:hidden p-2 rounded-full bg-primary/10 hover:bg-primary/20 transition-colors shadow focus:outline-none"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Open menu"
              >
                <MdMenu size={28} className="text-primary" />
              </button>
            </div>
            {/* Mobile Menu */}
            {isMenuOpen && (
              <motion.div 
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="md:hidden border-t border-border bg-card/95 rounded-b-2xl shadow-lg py-4 mt-2"
              >
                <nav className="flex flex-col space-y-3">
                  <button 
                    onClick={() => handleNavigation('/landing-page')}
                    className="text-left font-body text-sm text-foreground hover:text-primary px-3 py-2 rounded-lg hover:bg-primary/10"
                  >
                    Home
                  </button>
                  <button className="text-left font-body text-sm text-primary font-semibold">
                    About
                  </button>
                  <button 
  onClick={() => handleNavigation('/admissions&programs')}
  className="text-left font-body text-sm text-foreground hover:text-primary"
>
  Admissions & Updates
</button>
                  <button 
                    onClick={() => handleNavigation('/contact')}
                    className="text-left font-body text-sm text-foreground hover:text-primary px-3 py-2 rounded-lg hover:bg-primary/10"
                  >
                    Contact
                  </button>
                </nav>
              </motion.div>
            )}
          </div>
        </header>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-primary/5 via-background to-accent/5">
          {/* Student group photo as background */}
          <div
            className="absolute inset-0 w-full h-full z-0"
            style={{
              backgroundImage: "url('/assets/images/students-pic.jpeg')", // Save your student image as this path
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'brightness(0.55) blur(0.5px)',
            }}
            aria-hidden="true"
          />
          {/* Overlay for readability */}
          <div className="absolute inset-0 bg-black/40 z-10" aria-hidden="true" />
          <div className="relative z-20 container mx-auto px-4 lg:px-6 py-20">
            <motion.div 
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="text-center"
            >
              <div className="w-32 h-32 mx-auto mb-8 rounded-full overflow-hidden shadow-xl bg-white/80">
                <Image 
                  src="/assets/images/school_logo-1754996036714.jpg"
                  alt="Anglican College Owerrinta Logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <h1 className="text-4xl lg:text-6xl font-heading font-bold text-white mb-6 drop-shadow-lg">
                About Anglican College Owerrinta
              </h1>
              <p className="text-xl lg:text-2xl font-body text-primary mb-8 drop-shadow">
                Excellence through diligence
              </p>
              <p className="text-lg text-white max-w-4xl mx-auto drop-shadow">
                Anglican College Owerrinta is dedicated to nurturing students in academics, character, and leadership for a brighter future.
              </p>
            </motion.div>
          </div>
        </section>
        {/* Motto, Mission & Vision Section */}
        <section className="pt-12 pb-12 bg-gradient-to-br from-primary/10 via-background to-accent/10">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="max-w-4xl mx-auto text-center mb-12"
            >
              <h2 className="text-4xl lg:text-5xl font-heading font-extrabold text-primary mb-6 tracking-tight">
                School Motto
              </h2>
              <div className="flex flex-col items-center justify-center mb-8">
                <Icon name="Handshake" size={48} className="text-accent mb-2" />
                <p className="text-2xl lg:text-3xl font-body font-semibold text-muted-foreground bg-card px-6 py-3 rounded-xl shadow inline-block">
                  Excellence through diligence
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                <div>
                  <h3 className="text-2xl font-heading font-bold text-foreground mb-2">
                    Mission Statement
                  </h3>
                  <p className="text-lg font-body text-muted-foreground mb-2">
                    To provide quality education and foster the holistic development of every student.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-heading font-bold text-foreground mb-2">
                    Vision Statement
                  </h3>
                  <div className="bg-card px-6 py-4 rounded-xl shadow-lg inline-block">
                    <p className="text-lg font-body text-muted-foreground">
                      Raising a godly generation for the lord.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
        {/* Director & Founder Section */}
        <section className="py-16 bg-muted/10">
          <div className="container mx-auto px-4 lg:px-6">
            {/* "The Director/Proprietor" header centered at the top */}
            <h2 className="text-2xl sm:text-3xl font-heading font-bold text-primary mb-4 text-center">
              The Director/Proprietor
            </h2>
            {/* Director/Proprietor name centered below the header */}
            <div className="flex justify-center mb-6">
              <div className="bg-white/90 border border-primary/30 rounded-xl px-6 py-3 shadow font-semibold text-lg text-primary flex flex-wrap items-center gap-x-2 gap-y-1 text-center">
                Archbishop Isaac Chijioke Nwaobia, PhD, MSW, B.A., PGD (Journalism), Dip.Th, JP
              </div>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
              className="flex flex-col md:flex-row items-center gap-10 md:gap-16"
            >
              {/* Director Photo */}
              <div className="flex-shrink-0 w-full max-w-xs md:max-w-sm lg:max-w-md mx-auto">
                <div className="relative rounded-2xl overflow-hidden border-4 border-primary/40 shadow-xl bg-white">
                  <img
                    src="/assets/images/bishop-pic.jpg"
                    alt="Archbishop Isaac Chijioke Nwaobia, PhD, MSW, B.A., PGD (Journalism)"
                    className="w-full h-auto object-cover rounded-2xl"
                    style={{ aspectRatio: '3/4', objectPosition: 'top center' }}
                  />
                </div>
              </div>
              {/* Director Bio */}
              <div className="flex-1">
                <div className="bg-white/80 rounded-xl shadow p-6 text-base sm:text-lg text-muted-foreground font-body leading-relaxed">
                  <strong>Profile of Archbishop Isaac Chijioke Nwaobia, PhD, MSW, B.A., PGD (Journalism), Dip.Th, JP</strong><br /><br />
                  The Most Rev. Isaac Chijioke Nwaobia, PhD, JP, FCBA, is a distinguished cleric of the Anglican Communion and a respected scholar and administrator. He hails from Umuama, Amaku Nvosi in Isiala Ngwa South Local Government Area of Abia State, Nigeria.<br /><br />
                  He began his early education at Amaku Nvosi Community School and later attended Anglican Grammar School, Nbawsi. He proceeded to Trinity Union Theological College, Umuahia, where he obtained a Diploma in Religious Studies affiliated with the University of Calabar. He further earned a Bachelor of Arts Degree in Religious Studies from the University of Ibadan. Demonstrating a passion for academic excellence and social development, he obtained a Post Graduate Diploma in Journalism from Times Journalism Institute and later acquired a Master of Social Work (MSW) Degree from the University of Ibadan. He subsequently earned a Doctor of Philosophy (PhD) in Social Communication from Ashland University, Ohio, USA.<br /><br />
                  Archbishop Nwaobia began his ministerial service as a Church teacher and later proceeded for theological training. He was ordained Deacon in 1988 and Priest in 1989. In recognition of his faithful service and leadership qualities, he was installed as a Canon of St. Michael’s Cathedral, Aba in 1998 and later preferred as Archdeacon in 2005.<br /><br />
                  He was elected Bishop of the Diocese of Isiala Ngwa South (Anglican Communion) and consecrated Bishop in 2007. In 2019, he was elected the 3rd Archbishop of Aba Ecclesiastical Province of the Church of Nigeria (Anglican Communion).<br /><br />
                  Archbishop Nwaobia has served and continues to serve in several ecumenical and Christian bodies including the Christian Association of Nigeria (CAN), Christian Council of Nigeria (CCN), and Bible Society of Nigeria (BSN). He has received numerous awards and recognitions for his contributions to church growth, leadership development, and community service.<br /><br />
                  He is happily married to Mrs. Hope Njideka Nwaobia, and their union is blessed with children. Through his episcopal ministry, Archbishop Nwaobia has made significant spiritual, educational, and developmental contributions to the Church and society.
                </div>
              </div>
            </motion.div>
          </div>
        </section>
        {/* Proprietress Section (insert after Director/Proprietor section, before Principal section) */}
        <section className="py-16 bg-muted/10">
          <div className="container mx-auto px-4 lg:px-6">
            <h2 className="text-2xl sm:text-3xl font-heading font-bold text-primary mb-4 text-center">
              The Proprietress
            </h2>
            <div className="flex justify-center mb-6">
              <div className="bg-white/90 border border-primary/30 rounded-xl px-6 py-3 shadow font-semibold text-lg text-primary flex flex-wrap items-center gap-x-2 gap-y-1 text-center">
                Mrs. Hope Njideka Nwaobia
              </div>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
              className="flex flex-col md:flex-row items-center gap-10 md:gap-16"
            >
              {/* Proprietress Photo */}
              <div className="flex-shrink-0 w-full max-w-xs md:max-w-sm lg:max-w-md mx-auto">
                <div className="relative rounded-2xl overflow-hidden border-4 border-primary/40 shadow-xl bg-white">
                  <img
                    src="/assets/images/Proprietress-pic.png"
                    alt="Proprietress Anglican College Owerrinta"
                    className="w-full h-auto object-cover rounded-2xl"
                    style={{ aspectRatio: '3/4', objectPosition: 'top center' }}
                  />
                </div>
              </div>
              {/* Proprietress Caption */}
              <div className="flex-1">
                <div className="bg-white/80 rounded-xl shadow p-6 text-base sm:text-lg text-muted-foreground font-body leading-relaxed">
                 
                  As Proprietress of Anglican College Owerrinta, Mrs. Hope Njideka Nwaobia exemplifies dedication, compassion, and a steadfast commitment to the holistic development of every student. Her nurturing leadership and unwavering support inspire both staff and students to pursue excellence, integrity, and service to the community.
                </div>
              </div>
            </motion.div>
          </div>
        </section>
        {/* Leadership Team */}
        <section className="py-20">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div 
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="text-center mb-16"
            >
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
                The Principal
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Meet the Principal and staff who lead Anglican College Owerri with vision and commitment.
              </p>
            </motion.div>
            {/* Principal Card Centered */}
            <div className="flex justify-center">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.1 }}
                className="bg-card border border-border rounded-2xl shadow-2xl p-12 text-center hover:shadow-lg transition-shadow relative overflow-hidden max-w-xl w-full flex flex-col items-center"
              >
                <div 
                  className="absolute top-2 right-2 w-10 h-10 opacity-5 rounded-full"
                  style={{
                    backgroundImage: 'url(/assets/images/anglican-college-logo.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                ></div>
                <div className="w-44 h-44 rounded-full overflow-hidden mx-auto mb-8 border-4 border-primary/10 flex items-center justify-center" style={{ boxShadow: '0 0 32px #2563eb33', background: '#fff' }}>
                  <Image 
                    src={facultyMembers[0]?.photo}
                    alt={facultyMembers[0]?.name || 'Principal'}
                    className="w-full h-full object-cover object-top"
                    style={{ objectPosition: 'top center' }}
                  />
                </div>
                <Icon name="Award" size={48} className="text-primary mb-4" />
                <h3 className="text-3xl font-heading font-bold text-primary mb-2 min-h-[1.5em]">
                  {facultyMembers[0]?.name || <span className="text-muted-foreground italic">[Principal Name]</span>}
                </h3>
                <p className="text-xl font-semibold text-muted-foreground mb-2">
                  {facultyMembers[0]?.position}
                </p>
              </motion.div>
            </div>
          </div>
        </section>
        {/* Facilities */}
        <section className="py-20 bg-muted/30">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div 
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="text-center mb-16"
            >
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
                School Facilities
              </h2>
              <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
                Our facilities provide students with the resources they need for academic and personal growth.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {facilities.map((facility, idx) => (
                <motion.div
                  key={facility.name}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.1, delay: idx * 0.1 }}
                  className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-shadow flex flex-col items-center"
                >
                  <Icon name={facility.icon} size={32} className="text-primary mb-4" />
                  <h3 className="text-lg font-heading font-semibold text-foreground">
                    {facility.name}
                  </h3>
                  <p className="text-muted-foreground font-body text-sm text-center">
                    {facility.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
        {/* School Image Gallery */}
        <section className="py-16 bg-muted/5">
          <div className="container mx-auto px-4 lg:px-6">
            <div className="text-center mb-10">
              <h2 className="text-3xl lg:text-4xl font-heading font-bold text-primary mb-4">
                Our Campus
              </h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Explore our beautiful campus and modern facilities.
              </p>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
            >
              {schoolImages.map((img, index) => (
                <div key={index} className="flex flex-col items-center">
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.1, delay: index * 0.02 }}
                    className="relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 group cursor-pointer w-full"
                    onClick={() => setPreviewImg(img.src)}
                  >
                    <Image
                      src={img.src}
                      alt={img.alt}
                      className="w-full h-64 object-cover transform group-hover:scale-105 transition-transform duration-300"
                    />
                  </motion.div>
                  <div className="mt-3 text-center">
                    <h3 className="text-lg font-semibold font-heading text-muted-foreground">{img.caption}</h3>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </section>
{/* Why Choose Anglican College Owerrinta Section */}
<section className="py-16 bg-gradient-to-br from-primary/5 via-background to-accent/10">
  <div className="container mx-auto px-4 lg:px-6">
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className="text-center mb-12"
    >
      <h2 className="text-3xl lg:text-4xl font-heading font-bold text-primary mb-4">
        Why Choose Anglican College Owerrinta?
      </h2>
      <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
        Discover the unique advantages that set our institution apart and make us a preferred choice for holistic education and personal growth.
      </p>
    </motion.div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
        className="bg-white/90 border border-primary/10 rounded-xl shadow-lg p-8 flex flex-col items-center text-center"
      >
        <Icon name="Award" size={40} className="text-primary mb-4" />
        <h3 className="font-heading font-semibold text-lg text-primary mb-2">Academic Distinction</h3>
        <p className="text-muted-foreground">
          Our students consistently achieve outstanding results in both internal and external examinations, reflecting our commitment to academic excellence and effective teaching methodologies.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: 0.1 }}
        className="bg-white/90 border border-primary/10 rounded-xl shadow-lg p-8 flex flex-col items-center text-center"
      >
        <Icon name="Users" size={40} className="text-primary mb-4" />
        <h3 className="font-heading font-semibold text-lg text-primary mb-2">Holistic Development</h3>
        <p className="text-muted-foreground">
          We nurture not only the intellect but also the character and leadership potential of every student, ensuring they are well-prepared for life’s challenges and opportunities.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: 0.2 }}
        className="bg-white/90 border border-primary/10 rounded-xl shadow-lg p-8 flex flex-col items-center text-center"
      >
        <Icon name="ShieldCheck" size={40} className="text-primary mb-4" />
        <h3 className="font-heading font-semibold text-lg text-primary mb-2">Safe & Supportive Environment</h3>
        <p className="text-muted-foreground">
          Our campus provides a secure, inclusive, and nurturing atmosphere where students can thrive academically, socially, and morally under the guidance of experienced educators.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: 0.3 }}
        className="bg-white/90 border border-primary/10 rounded-xl shadow-lg p-8 flex flex-col items-center text-center"
      >
        <Icon name="Lightbulb" size={40} className="text-primary mb-4" />
        <h3 className="font-heading font-semibold text-lg text-primary mb-2">Modern Facilities</h3>
        <p className="text-muted-foreground">
          We offer state-of-the-art facilities, including science and ICT labs, a well-stocked library, and comfortable hostels, all designed to enhance the learning experience.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: 0.4 }}
        className="bg-white/90 border border-primary/10 rounded-xl shadow-lg p-8 flex flex-col items-center text-center"
      >
        <Icon name="Globe" size={40} className="text-primary mb-4" />
        <h3 className="font-heading font-semibold text-lg text-primary mb-2">Global Perspective</h3>
        <p className="text-muted-foreground">
          Our curriculum is designed to equip students with the knowledge and skills needed to excel in a rapidly changing world, fostering global awareness and adaptability.
        </p>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, delay: 0.5 }}
        className="bg-white/90 border border-primary/10 rounded-xl shadow-lg p-8 flex flex-col items-center text-center"
      >
        <Icon name="Heart" size={40} className="text-primary mb-4" />
        <h3 className="font-heading font-semibold text-lg text-primary mb-2">Community & Values</h3>
        <p className="text-muted-foreground">
          We instill strong moral values, a sense of responsibility, and a spirit of service, preparing our students to become compassionate and principled leaders in society.
        </p>
      </motion.div>
    </div>
  </div>
</section>

        {/* Contact CTA */}
        <section className="py-20 bg-gradient-to-br from-primary to-accent">
          <div className="container mx-auto px-4 lg:px-6">
            <motion.div 
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.1 }}
              className="text-center text-primary-foreground"
            >
              <div className="w-20 h-20 mx-auto mb-6 rounded-full overflow-hidden border-4 border-primary-foreground/20">
                <Image 
                  src="/assets/images/school_logo-1754996036714.jpg"
                  alt="Anglican College Owerrinta Logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <h2 className="text-3xl lg:text-4xl font-heading font-bold mb-4">
                Ready to Join Our School Community?
              </h2>
              <p className="text-xl mb-8 text-primary-foreground/80">
                Take the first step towards a life of knowledge, discipline, and leadership at Anglican College Owerrinta.
              </p>
            </motion.div>
          </div>
        </section>
        {/* Footer */}
        <footer className="bg-blue-100 border-t border-border py-12">
          <div className="container mx-auto px-4 lg:px-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {/* School Info */}
              <div className="col-span-1 md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <Image 
                      src="/assets/images/school_logo-1754996036714.jpg"
                      alt="Anglican College Owerrinta Logo"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-foreground">ANGLICAN COLLEGE OWERRINTA</h3>
                    <p className="font-caption text-sm text-muted-foreground">Excellence Through Diligence</p>
                  </div>
                </div>
                <p className="text-muted-foreground font-body mb-4">
                  Committed to providing exceptional education and fostering the growth of future leaders through innovative teaching methods and character development.
                </p>
                <div className="flex space-x-4">
                  <Button variant="ghost" size="icon">
                    <Icon name="Facebook" size={20} />
                  </Button>
                  <Button variant="ghost" size="icon">
                    <Icon name="Twitter" size={20} />
                  </Button>
                  <Button variant="ghost" size="icon">
                    <Icon name="Instagram" size={20} />
                  </Button>
                </div>
              </div>

              {/* Quick Links */}
              <div>
                <h4 className="font-heading font-semibold text-foreground mb-4">Quick Links</h4>
                <ul className="space-y-2 font-body text-sm">
                  <li><button onClick={() => handleNavigation('/about-page')} className="text-muted-foreground hover:text-primary">About Us</button></li>
                  <li><button onClick={() => handleNavigation('/admissions&programs')} className="text-muted-foreground hover:text-primary">Admissions & Updates</button></li>
                  <li><button className="text-muted-foreground hover:text-primary">Faculty</button></li>
                  <li><button onClick={() => handleNavigation('/contact')} className="text-muted-foreground hover:text-primary">Contact</button></li>
                </ul>
              </div>

              {/* Contact */}
              <div>
                <h4 className="font-heading font-semibold text-foreground mb-4">Contact Info</h4>
                <ul className="space-y-2 font-body text-sm text-muted-foreground">
                  <li className="flex items-center space-x-2">
                    <Icon name="MapPin" size={16} />
                    <span>Isiala Ngwa South, Abia State</span>
                  </li>
                  <li>
                    <h4 className="font-heading font-semibold text-primary mt-4 mb-2">School Support</h4>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Phone" size={16} />
                    <span>
                      <a href="/call?number=+2348166993771" className="underline text-primary hover:text-primary/80 transition">+2348166993771</a>
                    </span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Phone" size={16} />
                    <span>
                      <a href="/call?number=+2349077364848" className="underline text-primary hover:text-primary/80 transition">+2349077364848</a>
                    </span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Phone" size={16} />
                    <span>
                      <a href="/call?number=+2348063425289" className="underline text-primary hover:text-primary/80 transition">+2348063425289</a>
                    </span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Mail" size={16} />
                    <span>
                      <a href="mailto:anglicancollegesnrsch@gmail.com" className="underline text-primary hover:text-primary/80 transition">anglicancollegesnrsch@gmail.com</a>
                    </span>
                  </li>
                  {/* Technical Support Header and Numbers */}
                  <li>
                    <h4 className="font-heading font-semibold text-primary mt-4 mb-2">Technical Support</h4>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Smartphone" size={16} />
                    <span>
                      WhatsApp: <a href="https://wa.me/2348143316441" className="underline text-primary">+2348143316441</a>
                    </span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="Phone" size={16} />
                    <span>
                      Call: <a href="/call?number=+2349040744911" className="underline text-primary hover:text-primary/80 transition">+2349040744911</a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>

        {/* Image Preview Modal */}
        {previewImg && (
          <div
            className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
            onClick={() => setPreviewImg(null)}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.1 }}
              className="relative bg-card rounded-xl shadow-2xl p-4"
              onClick={e => e.stopPropagation()}
            >
              <button
                className="absolute top-2 right-2 bg-error/90 text-white rounded-full p-2 hover:bg-error transition-colors"
                onClick={() => setPreviewImg(null)}
                aria-label="Close"
              >
                <Icon name="X" size={24} />
              </button>
              <Image
                src={previewImg}
                alt="Preview Image"
                className="max-w-[90vw] max-h-[90vh] rounded-lg object-contain"
              />
            </motion.div>
          </div>
        )}
      </div>
    </>
  );
};

export default AboutPage;